const HAS_SESSION_KEY = 'hasSession';

export const authSession = {
    hasSession(): boolean {
        return localStorage.getItem(HAS_SESSION_KEY) === 'true';
    },

    setSession(): void {
        localStorage.setItem(HAS_SESSION_KEY, 'true');
    },

    clearSession(): void {
        localStorage.removeItem(HAS_SESSION_KEY);
    }
};
